import styled from "styled-components";

export const ChoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ChoiceOption = styled.label<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid ${({ selected }) => (selected ? "#0066cc" : "#e2e8f0")};
  background: ${({ selected }) => (selected ? "#f0f9ff" : "white")};
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 16px;
  color: #4a4d5e;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: #0066cc;
      background: #f0f9ff;
    }
  }

  input {
    accent-color: #0066cc;
    width: 18px;
    height: 18px;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  font-family: "Dosis", sans-serif;
  color: #4a4d5e;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: #0066cc;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.15);
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  font-family: "Dosis", sans-serif;
  color: #4a4d5e;
  outline: none;
  transition: border-color 0.2s;
  min-height: 120px;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    border-color: #0066cc;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.15);
  }
`;

export const SelectWrapper = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  font-family: "Dosis", sans-serif;
  color: #4a4d5e;
  outline: none;
  background: white;
  cursor: pointer;
  appearance: auto;
  box-sizing: border-box;

  &:focus {
    border-color: #0066cc;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.15);
  }
`;

export const DualSelectRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Pill = styled.button<{ selected?: boolean }>`
  padding: 10px 20px;
  border-radius: 24px;
  border: 2px solid ${({ selected }) => (selected ? "#0066cc" : "#e2e8f0")};
  background: ${({ selected }) => (selected ? "#0066cc" : "white")};
  color: ${({ selected }) => (selected ? "white" : "#4a4d5e")};
  font-size: 15px;
  font-family: "Dosis", sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;
  min-width: 48px;
  text-align: center;

  &:hover {
    border-color: #0066cc;
    background: ${({ selected }) => (selected ? "#0066cc" : "#f0f9ff")};
  }
`;

export const HeightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CheckboxGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** Checkbox rows: avoid ChoiceOption's strong hover (sticky on touch; reads as "always selected"). */
export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  font-size: 16px;
  color: #4a4d5e;

  &:has(input:checked) {
    border-color: #0066cc;
    background: #f0f9ff;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:has(input:checked)) {
      border-color: #cbd5e1;
      background: #f8fafc;
    }
  }

  input {
    accent-color: #0066cc;
    width: 18px;
    height: 18px;
  }
`;

export const ContactInfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4a4d5e;
  margin-bottom: 4px;
`;

export const DisplayContent = styled.div`
  font-size: 16px;
  color: #4a4d5e;
  line-height: 1.6;
  white-space: pre-line;

  p {
    margin: 0 0 12px;
  }
`;

export const EntryCard = styled.div`
  padding: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EntryCardRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 20px;
  border-radius: 12px;
  border: 2px dashed #cbd5e1;
  background: transparent;
  color: #0066cc;
  font-size: 15px;
  font-family: "Dosis", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  min-height: 44px;
  width: 100%;

  &:hover {
    border-color: #0066cc;
    background: #f0f9ff;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 8px;
  border-radius: 8px;
  border: none;
  background: #fef2f2;
  color: #dc2626;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: #fecaca;
  }
`;

export const NestedPanel = styled.div<{ $expanded?: boolean }>`
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.15s ease;

  ${({ $expanded }) => $expanded && "border-color: #0066cc;"}
`;

export const NestedPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 16px;
  border: none;
  background: #f8fafc;
  color: #4a4d5e;
  font-size: 16px;
  font-family: "Dosis", sans-serif;
  font-weight: 600;
  cursor: pointer;
  min-height: 44px;
  text-align: left;

  &:hover {
    background: #f1f5f9;
  }
`;

export const NestedPanelBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid #e2e8f0;
`;

export const VideoContainer = styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #000;

  video {
    display: block;
    width: 100%;
    max-height: 70vh;
  }
`;

export const DropdownReveal = styled.div<{ $visible?: boolean }>`
  overflow: hidden;
  max-height: ${({ $visible }) => ($visible ? "200px" : "0")};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: max-height 0.2s ease, opacity 0.2s ease;
  padding-top: ${({ $visible }) => ($visible ? "8px" : "0")};
`;
